<template>
<!-- 为灵活信号开启操作提供确认的modal页面，需要能比较友好的展示参数，作为用户最后的确认 -->
  <div>
    <Row>
      <Modal
        v-model="m_open_modal_switch"
        :loading="loading_status"
        width=60
        @on-ok="set_ok"
        @on-cancel="set_cancel"
        @on-visible-change="set_changed"
      >
        <p slot="header">
          <!-- <span>{{ this.get_modal_title() }}</span> -->
          <Row type="flex" justify="center" align="middle">
            <span>此操作将开启策略:</span>
            <span style="color:#ff9900;font-size:16px;font-weight:bold">{{ this.title[0] }}</span>
            <span>,绑定标的:</span>
            <span style="color:#ff9900;font-size:16px;font-weight:bold">{{ this.title[1] }}</span>
            <span>,请确认</span>
          </Row>
        </p>
        <Row>
          <Col span="20" offset="2">
            <Table :columns="params_columns" :data="params_data" border max-height=500 :span-method="handleSpan"></Table>
          </Col>
        </Row>
      </Modal>
    </Row>
  </div>
</template>
<script>
import store from '../../store'

export default {
  name: "flexible_render_modal_view_params_confirm",
  data() {
    return {
      m_open_modal_switch:false,
      loading_status:false,
      params_columns:[
        {
          title: '名称',
          key: 'name',
          align: "center",
          minWidth: 50
        },
        {
          title: '描述',
          key: 'description',
          align: "center",
          minWidth: 50
        },
        {
          title: '类型',
          key: 'type',
          align: "center",
          minWidth: 50
        },
        {
          title: '参数',
          key: 'params',
          align: "center",
          minWidth: 200
        },
        {
          title: '执行效率',
          key: 'execute_percent',
          align: "center",
          minWidth: 50
        },
      ],
      params_data:[
      ],
      guide_handle_span:{}
    }
  },
  props: {
    // 策略参数
    params: {
    },
    open_modal_switch: {
      type: Boolean,
      default: false
    },
    title: {
      type: [String, Array],
    },
    allow_msg_name_description_index: {
      type: Object
    }
  },
  methods:{
    get_modal_title() {
      return this.title
    },
    set_tables() {
      let open_paras_list = []
      let close_paras_list = []
      let function_type_list = []
      let default_list = []
      let account_msg_list = []

      for(var index in this.params) {
        var msg = this.params[index]
        // 填充创建/修改页签下的数据
        if (msg["type"] === "sign" && msg["open_or_close"] === "open") {
          open_paras_list.push([
            msg["name"], msg["paras"]
          ])
        } else if (msg["type"] === "sign" && msg["open_or_close"] === "close") {
          close_paras_list.push([
           msg["name"], msg["paras"], msg["execute_percent"]
          ])
        } else if (msg["type"] === "default") {
          default_list.push([
            msg["name"], msg["paras"],
          ])
        } else if (msg["type"] === "function_type") {
          function_type_list.push([
            msg["open_or_close"], msg["paras"]
          ])
        } else if (msg["type"] === "account_msg") {
          account_msg_list.push([
            msg["paras"][0], msg["paras"][1]
          ])
        }
      }
      this.params_data = []
      // 按顺序填充表格
      for (var i = 0; i < open_paras_list.length; i++) {
        this.params_data.push({
          "name":open_paras_list[i][0], "description":this.allow_msg_name_description_index[open_paras_list[i][0]], "type":"开仓", "params":open_paras_list[i][1]
        })
      }
      for (var i = 0; i < close_paras_list.length; i++) {
        this.params_data.push({
          "name":close_paras_list[i][0], "description":this.allow_msg_name_description_index[close_paras_list[i][0]], "type":"平仓","params":close_paras_list[i][1], "execute_percent":(close_paras_list[i][2]*100).toFixed(2)+"%"
        })
      }
      for (var i = 0; i < default_list.length; i++) {
        if (default_list[i][0] == "stop_gain") {
          this.params_data.push({
            "name":default_list[i][0], "description":this.allow_msg_name_description_index[default_list[i][0]], 
            "type":"固定参数", "params":this.$mul(Number(default_list[i][1][0]), 100) + "%"
          })
        } else {
          this.params_data.push({
            "name":default_list[i][0], "description":this.allow_msg_name_description_index[default_list[i][0]], 
            "type":"固定参数", "params":this.$mul(Number(default_list[i][1][0]), 100) + "%, " + this.$mul(Number(default_list[i][1][1]), 100) + "%"
          })
        }
      }
      var function_type_index = store.state.function_type_index
      for (var i = 0; i < function_type_list.length; i++) {
        this.params_data.push({
          "name":function_type_list[i][0], "description":"", "type":"订单执行", 
          "params":function_type_index[function_type_list[i][1][0]] + "," + this.$mul(Number(function_type_list[i][1][1]), 10000) + 
            "‱," + this.$mul(Number(function_type_list[i][1][2]), 10000) + "‱"
        })
      }
      for (var i = 0; i < account_msg_list.length; i++) {
        this.params_data.push({
          "name":"", "type":"绑定账户", "description":"", "params":account_msg_list[i][0]+"号账户", "execute_percent":(account_msg_list[i][1]*100).toFixed(2)+"%"
        })
      }

      // 指导合并单元格
      this.guide_handle_span = {}
      for (var i = 0; i < this.params_data.length; i++) {
        this.guide_handle_span[i] = [0, 0]
      }
      var sum = 0
      this.guide_handle_span[sum] = [open_paras_list.length, 1]
      sum += open_paras_list.length
      this.guide_handle_span[sum] = [close_paras_list.length, 1]
      sum += close_paras_list.length
      this.guide_handle_span[sum] = [function_type_list.length, 1]
      sum += function_type_list.length
      this.guide_handle_span[sum] = [default_list.length, 1]
      sum += default_list.length
      this.guide_handle_span[sum] = [account_msg_list.length, 1]
      
    },
    set_cancel() {
      this.$emit("params_confirm_click", {
        "mode":"cancel",
      })
    },
    set_ok() {
      this.$emit("params_confirm_click", {
        "mode":"ok",
      })
    },
    set_changed(value) {

    },
    handleSpan ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 1) {
        return this.guide_handle_span[rowIndex]
      }
    }
  },
  mounted: function() {
    
  },
  watch: {
    open_modal_switch(new_value, old_value) {
      // 避免直接由内部修改props的情况
      this.m_open_modal_switch = this.open_modal_switch
      if (this.m_open_modal_switch == true) {
        this.set_tables()
      } else {

      }
    },
  }
}
</script>
<style scoped>
.demo {
  font-size: 10px;
  border: 0px none transparent;
  background-color:transparent;
}
.demo-drawer-hearde {
  text-align:center;
}
.demo-hearde {
  color:"#2b85e4";
  font-size:"14px";
  font-weight:"bold";
  
}
</style>